<template>
    <b-card v-b-visible="mountedAction"
            class="dashboardCard" :class="widgetWidth">
        <template v-slot:header>
            <div class="d-inline-block">
                <div class="h6">{{ title }}</div>
                <div class="small" v-if="under_title_final">{{ under_title_final }}</div>
            </div>
            <b-button class="float-right">
                <i class="far" :class="expandGraphs ? 'fa-compress-arrows-alt': 'fa-expand-arrows-alt' "></i>
            </b-button>
        </template>

        <template>
            <div v-if="data == null && !showRaw" style="min-height: 200px; padding-top:80px;">
                <loading-spinner :busy="data == null && !showRaw"></loading-spinner>
            </div>


            <div v-else class="d-flex justify-content-between flex-column h-100">


                <!--data-->
                <ChartBarVertical v-if="showVertical" :data="chartData"></ChartBarVertical>
                <ChartBarHorizontal v-if="showHorizontal" :data="chartData"></ChartBarHorizontal>
                <ChartPie v-if="showPie" :data="chartData"></ChartPie>
                <div v-if="showRaw">
                    <ul v-if="!hasLinks" class="list-unstyled">
                        <li v-for="(label, i) in chartData.labels" :key="i" class="mb-2 pb-2 lead" style="border-bottom: 1px solid #e6e6e6">
                            <span class="font-weight-normal">{{ label }}</span>
                            <span class="float-right font-weight-bold">
                                {{ dataValuePrepend }}<template v-if="dataValueFormatFilter">{{
                                    $options.filters[dataValueFormatFilter](chartData.datasets[0].data[i]) }}</template>
                                <template v-else>{{ chartData.datasets[0].data[i] }}</template>{{ dataValueAppend }}
                            </span>
                        </li>
                    </ul>
                    <ul v-else  class="list-unstyled" :class="width == 100 ? 'split-columns' : '' ">
                        <li v-for="(link, i) in icons" :key="i" class="my-0 py-0" style="border-bottom: 1px solid #e6e6e6">
                            <a :href="link.url" class="d-block my-1 py-1">
                                <span class="font-weight-normal">{{ link.name }}</span>
                                <span class="float-right font-weight-bold">{{ chartData.datasets[0].data[i] }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <!--data-->







                <!--options buttons-->
                <div v-if="options" class="mt-4 text-center">
                    <div class="text-center h5 mb-2 font-uppercase">{{ current_option_formatted }}</div>
                    <b-button size="sm"
                              v-for="(opt,index) in options"
                              :key="index"
                              variant="outline-dark"
                              @click="setOption(opt, $event)"
                              class="mr-1 option-btn">
                        <small>{{ options_label[index] || opt }}</small>
                    </b-button>
                </div>
                <!--options buttons-->



                <!--chart type buttons-->
                <div class="mt-4 text-center">
                    <b-button variant="outline-dark" @click="toggleVertical" class="mr-1">
                        <i class="fa-light fa-grip-vertical"></i></b-button>
                    <b-button variant="outline-dark" @click="toggleHorizontal" class="mr-1">
                        <i class="fa-light fa-grip-horizontal"></i></b-button>
                    <b-button variant="outline-dark" @click="togglePie" class="mr-1">
                        <i class="fa-light fa-chart-pie-alt"></i></b-button>
                    <b-button variant="outline-dark" @click="toggleRaw">
                        <i class="fa-light fa-text-size"></i></b-button>
                </div>
                <!--chart type buttons-->


            </div>
        </template>





    </b-card>
</template>

<script>
    import ChartBarHorizontal from '../graphs/ChartBar-Horizontal.vue';
    import ChartBarVertical from '../graphs/ChartBar-Vertical.vue';
    import ChartPie from '../graphs/ChartPie.vue';
    import LoadingSpinner from '../../../components/LoadingSpinner';

    export default {
        components: {
            LoadingSpinner,
            ChartBarHorizontal,
            ChartBarVertical,
            ChartPie,
        },
        name: 'DashboardCard',
        props: {
            width: {type:Number, default: 25},
            color: {type:String, default: null},
            hasLinks: {type:Boolean, default: false},
            dataDisplay: {type:String, default: null},
            main_icon: {type:String, default: ''},
            load_url: String,
            icons: {
                type: Array,
                default: function () {
                    return [];
                } },
            time_wait: { type: Number, default: 10000000 },
            title: String,
            under_title: {type: String, default: null},
            options: {type: Array, default: null},
            options_label: {type: Array, default: null},
            dataValuePrepend: null,
            dataValueAppend: null,
            dataValueFormatFilter: null,
        },
        data(){
            return {
                expandGraphs: false,
                chartData: {
                    datasets: [{
                        barPercentage: 1,
                        barThickness: 30,
                        maxBarThickness: 30,
                        minBarLength: 1,
                        data: [],
                        backgroundColor: [],
                    }],
                    labels: [],
                    options: null,
                },
                under_title_final: null,
                current_option: null,
                current_option_formatted: null,
                hasAction: false,
                data: null,
                showVertical: true,
                showHorizontal: false,
                showPie: false,
                showRaw: false,
                showLine: false,
            };
        },
        beforeDestroy(){
            clearInterval(this.interaval);
        },
        computed: {
            widgetWidth:  function () {
                if(this.width == 100) {
                    return 'width-100';

                } else if (this.width == 50) {
                    return 'width-half';
                } else if (this.width == 33) {
                    return 'width-thrids';
                } else {
                    return 'width-quarters';
                }
            },
        },
        watch: {
            current_option: function(val) {
                val = val.replace(/_/g, ' ');
                if(val == 'last7days') {
                    val = 'Last 7 Days';
                }
                this.current_option_formatted = val;
            },
        },
        methods:{
            mountedAction(viewable) {
                if(!this.hasAction && viewable) {
                    this.callAPI();
                    this.interaval = setInterval(
                            this.callAPI,
                            this.time_wait
                    );
                    this.hasAction = true;
                }
            },
            callAPI: function () {
                var _this = this;
                var url = this.load_url;

                if( this.current_option ) {
                    url += '/' + this.current_option;
                } else if ( this.options ) {
                    this.current_option = this.options[0];
                    url += '/' + this.current_option;
                }

                this.$http.post(url).then(response => {
                    _this.data = response.data.data;
                    if(_this.data['sub_title']) {
                        _this.under_title_final = _this.data['sub_title'];
                        delete _this.data['sub_title'];
                    } else {
                        _this.under_title_final = _this.under_title;
                    }
                    if(!this.data.labels && !Array.isArray(_this.data)) {
                        _this.data = _.assign([], _this.data);
                    }
                    // dummie data
//                    let dummieData = '{"labels":["OB Create Payment Issue","OB Follow Up","OB Kit Request - Non Converted","OB Kit Request - Non Converted 2","OB Offer Ready","OB Welcome"],"chart_data":[32,67,95,0,52,30],"cached":"false"}';
//                    dummieData = JSON.parse(dummieData);
//                    _this.data = dummieData;
                    // dummie data


                    _this.createChartData();
                    _this.checkDisplayType();


                    if(this.dataDisplay == 'pie') {
                        if( _this.data.every(item => item == 0)) {
                            _this.toggleRaw();
                        }
                    }
                });
            },

            createChartData() {
                let that = this;
                that.chartData.datasets[0].data = [];
                that.chartData.labels = [];

                if(Array.isArray(this.data)) {
                    let labels = this.icons;
                    labels.forEach( function (label, i) {
                        that.chartData.labels.push(label.name);
                        that.chartData.datasets[0].data.push( that.data ? that.data[i] : 0);
                        that.chartData.datasets[0].backgroundColor.push( label.text_color );
                    });

                } else {
                    let labels = this.data.labels;
                    labels.forEach( function (label, i) {
                        that.chartData.labels.push(label);
                        that.chartData.datasets[0].data.push( that.data.chart_data[i]);
                        that.chartData.datasets[0].backgroundColor.push(that.color ? that.color : 'rgba(32, 168, 216, .6)');
                    });
                }



            },
            setOption(option, e){
                document.querySelectorAll('.option-btn').forEach(function (btn) {
                    btn.classList.remove('active');
                });
                e.target.classList.add('active');
                this.current_option = option;
                this.callAPI();
            },












            checkDisplayType() {
                if(this.dataDisplay == 'text') {
                    this.toggleRaw();
                }
                if(this.dataDisplay == 'pie') {
                    this.togglePie();
                }
            },
            hideAllGraphs() {
                this.showPie = false;
                this.showHorizontal = false;
                this.showVertical = false;
                this.showRaw = false;
                this.showLine = false;
            },
            toggleVertical() {
                this.hideAllGraphs();
                this.showVertical = !this.showVertical;
            },
            toggleHorizontal() {
                this.hideAllGraphs();
                this.showHorizontal = !this.showHorizontal;
            },
            togglePie() {
                this.hideAllGraphs();
                this.showPie = !this.showPie;
            },
            toggleRaw() {
                this.hideAllGraphs();
                this.showRaw = !this.showRaw;
            },
            toggleLine() {
                this.hideAllGraphs();
                this.showLine = !this.showLine;
            },
        },
    };

</script>


<style scoped>

    .dashboardCard {
        flex: 1;
        margin:20px 1%;
        max-width: 48%;
    }

    .width-thrids {
        flex-basis: 31%;

    }
    .width-quarters {
        flex-basis: 23%;
    }
    .width-50 {
        flex-basis: 48%;
    }
    .width-100 {
        flex-basis: 100%;
        max-width: 100% !important;
    }

    .split-columns {
        column-count: 4;
        column-gap: 3%;
    }
    .font-uppercase {
        text-transform: uppercase;
    }

</style>